/* eslint-disable */
/**
 * 存储sessionStorage
 */
export const setSessionStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getSessionStore = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeSessionStore = name => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}

/**
 * 存储localStorage
 */
export const setLocalStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getLocalStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeLocalStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop
  } else if (element.currentStyle) {
    target = element.currentStyle[attr]
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr]
  }
  // 在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode === 'float' ? parseFloat(target) : parseInt(target)
}
/**
 * 休眠方法
 * @param time ：number 休眠时间（s）
 */
export const sleep = async (time) => {
  await new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}
/**
 * 获取随机整数值
 */
export const getRandomNum = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min)
}

export const saveLocalStorage = (url, xml) => {
  if (localStorage.getItem('userName') && localStorage.getItem('userName') === 'guestall') {
    return
  }

  let saveObj
  if (localStorage.getItem('xmls')) {
    saveObj = JSON.parse(localStorage.getItem('xmls'))
  } else {
    saveObj = {}
  }
  let currentObj = {}
  currentObj[url] = xml
  localStorage.setItem('xmls', JSON.stringify(Object.assign(saveObj, currentObj))
)
}




// WEBPACK FOOTER //
// ./src/lib/mUtils.js